export const DATA_UPLOAD_REQUEST = 'DATA_UPLOAD_REQUEST'
export const DATA_UPLOAD_SUCCESS = 'DATA_UPLOAD_SUCCESS'
export const DATA_UPLOAD_FAIL = 'DATA_UPLOAD_FAIL'
export const DATA_UPLOAD_RESET = 'DATA_UPLOAD_RESET'

export const DATA_SEARCH_REQUEST = 'DATA_SEARCH_REQUEST'
export const DATA_SEARCH_SUCCESS = 'DATA_SEARCH_SUCCESS'
export const DATA_SEARCH_FAIL = 'DATA_SEARCH_FAIL'
export const DATA_SEARCH_RESET = 'DATA_SEARCH_RESET'
